import { useEffect, useRef } from 'react'

/**
 * Хук для предотвращения засыпания экрана и снижения приоритета вкладки.
 * Работает только если вкладка видна. (не свернут браузер, не переключена вкладка браузера)
 * @param enabled - условие, при котором замок должен быть активен
 */
export const useWakeLock = (enabled: boolean) => {
  const wakeLockRef = useRef<any>(null)

  useEffect(() => {
    const requestLock = async () => {
      if ('wakeLock' in navigator && enabled && !wakeLockRef.current) {
        try {
          wakeLockRef.current = await (navigator as any).wakeLock.request('screen')

          wakeLockRef.current.addEventListener('release', () => {
            wakeLockRef.current = null
          })
        } catch (err: any) {
          console.warn(`[WakeLock] not active`)
        }
      }
    }

    requestLock()

    // Запрос блокировки при возвращении на вкладку
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        requestLock()
      }
    }

    document.addEventListener('visibilitychange', handleVisibility)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility)

      if (wakeLockRef.current) {
        wakeLockRef.current.release()
        wakeLockRef.current = null
      }
    }
  }, [enabled])
}
